import React, { PureComponent } from 'react';
import { Row, Col } from 'antd';
import styles from './index.less';

export default class App extends PureComponent {
  render() {
    return (
      <Row className={styles.banner}>
        <Col className="frame-wrapper">
          <h1 className={styles.title}>{this.props.title}</h1>
        </Col>
      </Row>
    );
  }
}
